/* eslint-disable */
export default class {
	/**
	 * Execute a function given a delay time
	 *
	 * @param {type} func
	 * @param {type} wait
	 * @param {type} immediate
	 * @returns {Function}
	 */
	debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this,
				args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	/**
	 * Return the full path for the current url
	 */
	getFullPath() {
		return (
			location.protocol +
			'//' +
			location.hostname +
			(location.port ? ':' + location.port : '')
		);
	}

	/**
	 * JavaScript KeyCodes
	 */

	keycodes($key) {
		let codes = {
			escape: 27,
			a: 65,
			z: 90,
			down: 40,
			up: 38,
			enter: 13,
		};

		if ($key) {
			return codes[$key];
		} else {
			return codes;
		}
	}

	/**
	 * Promises helpers functions
	 */

	checkStatus(response) {
		if (response.ok) {
			return Promise.resolve(response);
		} else {
			return Promise.reject(new Error(response.statusText));
		}
	}

	parseJSON(response) {
		return response.json();
	}

	isMobile() {
    return window.matchMedia("only screen and (max-width: 760px)").matches;
	}
}



// WEBPACK FOOTER //
// ./scripts/util/ac-utils.js